export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-foreground-900 font-heading text-lg font-bold">
                哈哈影院
              </span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              哈哈影院 - 高清免费在线观影平台。提供电影、电视剧、综艺、动漫等海量高清影视资源，播放不缓冲不卡顿，每日同步更新，全端适配，随时随地畅享流畅追剧体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-foreground-800 font-medium mb-4 text-sm">快速导航</h3>
            <div className="space-y-2">
              {[
                { label: '最新更新', href: '#updates' },
                { label: '精选专题', href: '#carousel' },
                { label: '热播榜单', href: '#ranking' },
                { label: '影视推荐', href: '#cards' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-foreground-800 font-medium mb-4 text-sm">影视分类</h3>
            <div className="space-y-2">
              {['热门电影', '电视剧集', '综艺娱乐', '动漫番剧', '纪录片', '动作大片', '悬疑惊悚'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  className="block text-foreground-500 hover:text-foreground-800 text-sm transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div>
            <h3 className="text-foreground-800 font-medium mb-4 text-sm">合作伙伴</h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              哈哈影院欢迎优质内容方与技术伙伴加入合作生态，共同为影迷打造更好的观影体验。合作洽谈请通过页面内联系方式与我们取得联系。
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-10 pt-6 border-t border-background-200/40">
          <p className="text-foreground-400 text-xs">
            &copy; 2020 - 2026 哈哈影院 hahacinema.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}